import { QuoteGateway } from './quote-gateway.interface';

const baseUrl = 'gk/configurations';
export class HttpQuoteGateway implements QuoteGateway {
  postQuote(args: { projectId: string; configurations: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/quote`,
      method: 'POST',
      data: { configurations: args.configurations },
    };
  }

  patchQuote(args: {
    projectId: string;
    quoteId: string;
    configurations: any;
  }) {
    return {
      url: `${baseUrl}/${args.projectId}/quote/${args.quoteId}`,
      method: 'PATCH',
      data: { configurations: args.configurations },
    };
  }

  deleteQuote(args: { projectId: string; quoteId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/quote/${args.quoteId}`,
      method: 'DELETE',
    };
  }
}
